<div class="subscription-error-container">
  <div class="error-content">
    <div class="image">
      <mat-icon svgIcon={{pageConfig.icon}}></mat-icon>
    </div>
    <h1 class="error-title"> {{ pageConfig.header | translate}}
    </h1>
    <p class="error-message left-align">
      {{ pageConfig.body | translate }}
    </p>
    <p class="error-suggestion">
      <b>{{ pageConfig.footer | translate }}</b>
    </p>
    <button type="button"
            *ngIf="pageConfig.label != 'default'"
            class="btn btn-primary waves-effect waves-primary mt-2"
            (click)="navigateTo(pageConfig.url)">
      Get a Demo
    </button>
    <div *ngIf="pageConfig.label == 'default'">
      <ul>
        <li>
          <a class="text-secondary" (click)="navigateTo('https://info.dentalintel.com/cbj')">
          {{ 'OH_NO.PATIENT_CHAT.LABEL' | translate }}
          </a>
        </li>
        <li>
          <a class="text-secondary" (click)="navigateTo('https://info.dentalintel.com/rh0')">
          {{ 'OH_NO.TEAM_CHAT.LABEL' | translate }}
          </a>
        </li>
        <li>
          <a class="text-secondary" (click)="navigateTo('https://info.dentalintel.com/fp3')">
          {{ 'OH_NO.ANALYTICS.LABEL' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
